const styles = {
  icon: {
    marginRight: 16,
    fontSize: 24,
  },
  input: {
    marginBottom: 16,
  },
  button: {
    marginLeft: 16,
  },
  text: {
    marginBottom: 4,
    fontWeight: 600,
  },
  whiteBackground: {
    background: "white",
    marginBottom: 32,
    marginRight: 16,
  },
};

export default styles;
